/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Statement_Tree_Csv_Import_SuccessInputs */

const en_statement_tree_csv_import_success = /** @type {(inputs: Statement_Tree_Csv_Import_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imported ${i?.count} statement-tree row(s) from CSV — save to keep them`)
};

const nl_statement_tree_csv_import_success = /** @type {(inputs: Statement_Tree_Csv_Import_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} stamboomregel(s) geïmporteerd uit CSV — sla op om ze te bewaren`)
};

/**
* | output |
* | --- |
* | "Imported {count} statement-tree row(s) from CSV — save to keep them" |
*
* @param {Statement_Tree_Csv_Import_SuccessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_csv_import_success = /** @type {((inputs: Statement_Tree_Csv_Import_SuccessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Csv_Import_SuccessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_csv_import_success(inputs)
	return en_statement_tree_csv_import_success(inputs)
});